module.exports = __webpack_public_path__ + "static/media/myright.8f529573.jpg";